import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CardholderAccountStatuses = {
  INACTIVE: 0,
  ACTIVE: 1,
  REQUIRE_ACTION: 2,
  DELETED: 3,
  DISABLED: 4,
} as const

export type CardholderAccountStatusEnum = Enum<typeof CardholderAccountStatuses>
